// NOTE: This file was automatically generated by a script. Do not modify this file manually.
// To regenerate this file, please use `pnpm scripts:microbootstrap-generator reports`
// The command will generate files in the 'frontend/artifacts' folder with the list of files using collections
import { PropsWithChildren } from 'react'

import {
  CollectionBootstrapConfig,
  CollectionsBootstrap as CoreCollectionsBootstrap,
} from 'modules/core/components/CollectionsBootstrap'

import companies from 'modules/core/store/collections/companies'
import employees from 'modules/employees/store/collections/employees'
import features from 'modules/core/store/collections/features'
import legalEntities from 'modules/core/store/collections/legalEntities'
import locations from 'modules/locations/store/collections/locations'
import teams from 'modules/teams/store/collections/teams'
import users from 'modules/core/store/collections/users'

const CollectionsBootstrap = ({ children }: PropsWithChildren) => {
  const collections: CollectionBootstrapConfig[] = [
    [companies, {}] /* Referenced by 8231 cases in this module */,
    [employees, {}] /* Referenced by 7 cases in this module */,
    [features, {}] /* Referenced by 134 cases in this module */,
    [legalEntities, {}] /* Referenced by 8034 cases in this module */,
    [locations, {}] /* Referenced by 80 cases in this module */,
    [teams, {}] /* Referenced by 83 cases in this module */,
    [users, {}] /* Referenced by 907 cases in this module */,
  ] /* Generated file 👉 artifacts/reports-module-index.tsx-collection-dependencies-report-v2.json */

  return <CoreCollectionsBootstrap collections={collections}>{children}</CoreCollectionsBootstrap>
}

export default CollectionsBootstrap
